export default __webpack_public_path__ + "static/media/Nescient Helm.cbad43b4.jpg";